// extracted by mini-css-extract-plugin
export default {"label":"Label_label__UjWUY","required":"Label_required__LEqSm"};